// * config.local.js

import React from "react";

export default function AutorizationTopBar(props) {
    function onClick() {
        location = "/";
    }

    return (
        <div className="authorization-top-bar">
            <button type="button" className="app-title" onClick={onClick}>
                {(Config?.APP_TITLE || "").toLowerCase()}
            </button>
        </div>
    );
}
